module.exports = __webpack_public_path__ + "static/media/entranceP.f391590c.jpg";